/**
 * Footer du widget météo : libellé de la variable active + source/MAJ à gauche,
 * onglets de bascule de variable à droite (T° / Pluie / Vent / Hum.).
 *
 * Cible tactile des onglets : h-9 (36 px) — un peu sous les 44 px stricts mais
 * acceptable pour un contrôle secondaire ; le bouton "Replier" du header reste
 * en 44 px (cible primaire).
 */

import { VARIABLES } from "./constants.js";
import { formatFetchedAt } from "./formatters.js";
import type { VariableMeteo } from "./types.js";

export function FooterOnglets({
  variableActive,
  onChange,
  fetchedAt,
}: {
  variableActive: VariableMeteo;
  onChange: (v: VariableMeteo) => void;
  fetchedAt: string;
}) {
  const config = VARIABLES[variableActive];
  return (
    <div className="flex flex-wrap items-center justify-between gap-3">
      <div className="flex flex-col gap-0.5 text-[11px] text-champagne-700 sm:flex-row sm:items-center sm:gap-2">
        <span>{config.libelleLegende}</span>
        <span className="hidden sm:inline">·</span>
        <span>Open-Meteo · MAJ {formatFetchedAt(fetchedAt)}</span>
      </div>
      <div
        role="tablist"
        aria-label="Variable météo affichée"
        className="flex gap-1 rounded-md border border-champagne-200 bg-white p-0.5"
      >
        {(Object.keys(VARIABLES) as VariableMeteo[]).map((cle) => {
          const conf = VARIABLES[cle];
          const actif = cle === variableActive;
          const IconeOnglet = conf.iconeOnglet;
          return (
            <button
              key={cle}
              type="button"
              role="tab"
              aria-pressed={actif}
              aria-selected={actif}
              onClick={() => onChange(cle)}
              // 44 px de haut sous `lg` : ce sont de vrais boutons (pas des
              // libellés cliquables), et 36 px est sous le seuil confortable
              // au doigt — a fortiori avec les mains froides ou humides.
              className={`inline-flex h-11 items-center gap-1.5 rounded-sm px-3 text-[12px] transition-colors lg:h-9 lg:px-2.5 ${
                actif
                  ? "bg-champagne-900 text-champagne-50"
                  : "text-champagne-800 hover:bg-champagne-100"
              }`}
            >
              <IconeOnglet aria-hidden className="h-3.5 w-3.5" strokeWidth={1.7} />
              {conf.libelleOnglet}
            </button>
          );
        })}
      </div>
    </div>
  );
}
